<template>
  <div>
    <md-dialog
      :md-active.sync="value"
      class="mkt-ops -main-font dialog-alert-condition"
      :md-click-outside-to-close="false"
    >
      <md-dialog-title>Alert Message</md-dialog-title>
      <div class="layout-dialog">
        <div class="dialog-content">
          <div style="font-weight: bold; width: 27%;">
            Product complete : &ensp;
          </div>
          <div style="width: 73%;">
            {{ completeProduct == "" ? 0 : completeProduct }} &ensp; items.
          </div>
        </div>
        <div class="dialog-content">
          <div style="font-weight: bold; width: 20%; height: 18vh">
            Lost product : &ensp;
          </div>
          <div style="width: 80%;" class="scrollbar">
            {{ lostProduct }}
          </div>
        </div>
        <div class="dialog-content -conditions" style="width: 92%;">
          <div class="title" style="width: 100%;">Check conditions</div>
          <div style="width: 100%;">
            <ul>
              <li>Product ที่มีสถานะเป็น Inactive จะไม่นำมาแสดง</li>
              <li>
                Product ที่มี Product Lift Cycle นอกจากที่กำหนดไว้ จะไม่นำมาแสดง
              </li>
              <li>Product ที่ไม่มีการตั้งราคา A3 ไว้ จะไม่นำมาแสดง</li>
              <li>
                Product ที่มี Item Group = BM3 : Materials Product Pur. (Local)
                และ BM5 : Materials Product Pur (Import) จะไม่นำมาแสดง
              </li>
            </ul>
          </div>
        </div>
      </div>
      <md-dialog-actions class="-action">
        <md-button class="md-primary -confirm" @click="onCilckOK()"
          >OK</md-button
        >
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<script>
export default {
  name: "dialog-alert-condition",
  props: ["value", "completeProduct", "lostProduct"],
  watch: {},
  create() {},
  data() {
    return {};
  },
  methods: {
    onCilckOK() {
      this.$emit("cilckOK");
    }
  }
};
</script>

<style lang="scss" scoped>
.dialog-alert-condition {
  width: 50%;
  max-width: 50% !important;
  height: 60%;
  transform: unset !important;
  top: 20% !important;
  left: 25% !important;
  z-index: 19;

  .dialog-content .scrollbar {
    overflow-y: scroll;
    height: calc(60vmin - 315px);

    &::-webkit-scrollbar {
      height: 7px;
      width: 5px;
    }
  }

  .md-dialog-title {
    &.md-title {
      font-size: 18px;
      margin-bottom: 5px;
      padding: 21px 30px 0;
      font-weight: bold;
    }
  }

  .layout-dialog {
    padding: 10px 15px 5px 30px;
    display: block;
    height: 100%;
    font-size: 15px;

    .dialog-content {
      width: 100%;
      display: flex;
      margin-top: 10px;

      &.-conditions {
        margin-top: 30px;
        display: block;
        color: red;
        position: absolute;
        bottom: 55px;
        left: 30px;

        .title {
          font-weight: bold;
        }

        ul {
          margin: 10px;
        }

        ul,
        li {
          font-family: kanit;
          width: 100%;
          // color: red;
        }
      }
    }
  }

  .-action {
    padding-right: 15px;
    padding-bottom: 20px;

    .-confirm {
      color: #3f51b5;
      font-weight: bold;
      font-size: 16px;
      margin-left: 10px;
    }
  }
}
</style>
